module.exports = __webpack_public_path__ + "static/media/CTLI_2-235w.58157c05.png";